// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"b906301f","419":"64bb9be1","459":"dfa6dc79","505":"9255b0fa","631":"8d189ed6","774":"90de95c5","858":"014e5fc1","942":"9a16324a"}[chunkId] + ".chunk.js";
};